import React from 'react';
import { useTranslation } from 'react-i18next';

import { Fade } from '@material-ui/core';

import { Table } from 'components/Tools/Table';
import { TableContainer } from 'app/WMS/styles/styles';

import { IBatchData, IBatchTableProps } from '../../types';

const BatchTable: React.FC<IBatchTableProps> = ({ batchs }) => {
  const { t } = useTranslation();

  return (
    <Fade in timeout={1000} unmountOnExit>
      <TableContainer>
        <Table<IBatchData>
          columns={[
            {
              title: String(t('screens.commom.order')),
              type: 'string',
              props: ['codigoPedido'],
              orderable: true,
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '5%',
              },
            },
            {
              title: String(t('screens.commom.invoice')),
              type: 'string',
              props: ['notaFiscal'],
              orderable: true,
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '5%',
              },
            },
            {
              title: String(t('screens.commom.product')),
              props: ['produto'],
              type: 'string',
              orderable: true,
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: String(t('screens.commom.description')),
              props: ['descProduto'],
              type: 'string',
              orderable: true,
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '5%',
              },
            },
            {
              title: String(t('screens.commom.grid')),
              props: ['grade'],
              type: 'string',
              display: 'notEmpty',
              orderable: true,
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '5%',
              },
            },
            {
              title: String(t('screens.reportReceipt.batch')),
              props: ['lote'],
              type: 'string',
              display: 'notEmpty',
              orderable: true,
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '5%',
              },
            },
            {
              title: String(t('screens.commom.quantity')),
              orderable: true,
              type: 'string',
              props: ['quantidade'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '5%',
              },
            },
            {
              title: String(t('screens.reportReceipt.series')),
              orderable: true,
              type: 'string',
              props: ['serie'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '1%',
              },
            },
            {
              title: String(t('screens.commom.color')),
              orderable: true,
              type: 'string',
              display: 'notEmpty',
              props: ['cor'],
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '5%',
              },
            },
            {
              title: String(t('screens.commom.size')),
              orderable: true,
              type: 'string',
              props: ['tamanho'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '5%',
              },
            },
            {
              title: String(t('screens.receivement.requestType')),
              orderable: true,
              type: 'string',
              props: ['tipoPedido'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '5%',
              },
            },
            {
              title: String(t('screens.pickingConference.validity')),
              orderable: true,
              type: 'date',
              props: ['validade'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '5%',
              },
            },
            {
              title: String(t('screens.receivement.dateReceivement')),
              orderable: true,
              type: 'string',
              props: ['dataRecebimento'],
              display: 'notEmpty',
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '5%',
              },
            },
          ]}
          defaultNumberOfRows={100}
          rows={batchs}
          exportList
        />
      </TableContainer>
    </Fade>
  );
};

export default BatchTable;
